<template>
    <div class="container">
        <div class="row">
            <div class="amf-primitive three-column three">
              <amf-search-box
                :search="searchEmployers"
                @select="onSelectEmployer"
                label="AMF Code or Employer Name"
                :showResultAfterSelection="true"
                :showClearButton="true"
                @clear="onClearEmployer"
                :autofocus="true"
              >
              </amf-search-box>
            </div>
            <div class="amf-primitive three-column three">
              <user-search
                :onSelectUser="onSelectUser"
                label="Assigned To"
                :showResultAfterSelection="true"
                :showClearButton="true"
                @clear="onClearUser"
              >
              </user-search>
            </div>
            <amf-select
              label="Role"
              v-model="data.role"
              caption="--Select--"
              :options="roles"
              v-on:input="onSelectRole"
              :columns="3"
            />
            <amf-select
              label="Type"
              v-model="data.type"
              caption="--Select--"
              :options="filteredTypes"
              :columns="3"
              mapName="displayName"
              mapId="itemType"
            />
            <amf-input v-model="data.actionItemId" label="Action Item Id" :columns="3" :validator="$v.data.actionItemId"/>
            <amf-input v-model="data.comment" label="Action Item Comments" :columns="3" />
            <amf-checkbox v-model="data.includeCompletedItems" no-tracking label="Include Completed Items" :columns="3" style="margin-bottom: .05rem;margin-top: .2rem"/>
            <amf-checkbox v-model="data.includeFutureItems" no-tracking label="Include Future Items" :columns="3" style="margin-bottom: .05rem"/>
            <amf-checkbox v-model="data.includeParticipantItems" no-tracking label="Include Participant Items" :columns="3" style="margin-bottom: .05rem"/>
         </div>
    </div>
</template>

<script>
import UserSearch from "../shared/UserSearch";
import { actionItemUserRolesMap, userRoleMap } from "../user/user-labels";

    export default {
        components: {UserSearch},
         data() {
            return {
                data: {
                    employerId: null,
                    assignedToId: null,
                    role: null,
                    includeCompletedItems: false,
                    includeParticipantItems: false,
                    includeFutureItems: false,
                    type: null,
                    comment: null,
                    actionItemId: null,
                },
                title: 'Action Item Search',
                allTypes: [],
                filteredTypes: [],
                roles: [],
            }
        },
        async created() {
            this.load();
        },
        methods: {
          ...amfx.map("actionItems", "getActionItemTypes"),
          onSelectEmployer(employer) {
              if (employer != null) {
                this.data.employerId = employer.id;
              }
            },
            onSelectUser(user) {
              if (user != null) {
                this.data.assignedToId = user.id;
              }
            },
            onSelectRole(role) {
              if (!role) {
                this.filteredTypes = [...this.allTypes];
                return;
              }

              this.filteredTypes = this.allTypes.filter(x => x.assignToRoles.includes(role));
            },
            onClearEmployer() {
              this.data.employerId = null;
            },
            onClearUser() {
              this.data.assignedToId = null;
            },
            async load() {
              this.busy = true;
                let types = await this.getActionItemTypes();
                let actionTypes = types.map(aiType => ({
                  ...aiType,
                  displayName: (aiType.source === 2 ? `(Custom) ${aiType.displayName}` : aiType.displayName)
                }));
                this.allTypes = [...actionTypes];
                this.filteredTypes = [...actionTypes];

                let roles = await this.getRoles();
                this.roles = _.sortBy(roles, ['name']);
              this.busy = false;
            },
            async search(){
                return {
                    employerId : this.data.employerId,
                    assignedToId: this.data.assignedToId,
                    role: this.data.role,
                    includeCompletedItems: this.data.includeCompletedItems,
                    includeParticipantItems: this.data.includeParticipantItems,
                    includeFutureItems: this.data.includeFutureItems,
                    type: this.data.type,
                    comment: this.data.comment,
                    actionItemId: this.data.actionItemId
                }
            },
            async searchEmployers(text) {
              const results = await romeApi.get('/employer/search', { text });
              return results.map(r => ({
                id: r.employerId,
                icon: "fa-building",
                title: `${r.employerName} (${r.amfCode})`
              }));
            },
            async getRoles(){
              let roles = await romeApi.get('/actionitem/v-2/roles');
              return roles.map(x => ({
                id: x,
                name: actionItemUserRolesMap[x] ? actionItemUserRolesMap[x].name : userRoleMap[x] ? userRoleMap[x].name : x
              }));
            },
            validate() {
                if(this.data.actionItemId) return;
                const atLeastOneOfTheseIsRequired = ['employerId', 'assignedToId', 'role', 'type'];
                const atLeastOneIsPopulated = atLeastOneOfTheseIsRequired.map(x => this.data[x]).some(x => !!x);
                if (!atLeastOneIsPopulated) {
                  return "One of the following must be provided: Employer, Assigned To User, Role, Type";
                }
                return;
            },
        },
        computed:{
            buttons() {
                return "Search/Close";
            },
            includeCompletedItemsVisible(){
                return this.minimumFieldsPopulated;
            }
        },
        validations() {
            return {
              data: {
                actionItemId: v.build(v.integer()),
              }
            }
        }
    }
</script>

<style></style>



// WEBPACK FOOTER //
// src/action-items/ActionItemsSearch.vue